import { render, staticRenderFns } from "./1300_KSAT24-45-Red_Flags_Exercise.vue?vue&type=template&id=344cb3ba&scoped=true&lang=pug"
var script = {}
import style0 from "./1300_KSAT24-45-Red_Flags_Exercise.vue?vue&type=style&index=0&id=344cb3ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344cb3ba",
  null
  
)

export default component.exports